module.exports = __webpack_public_path__ + "img/kort-27.eb317779.jpeg";